import React, { useState, useEffect } from "react";
import Iframe from 'react-iframe'
import dataProvider from "../../services/DataProvider";

import Navigation from "../../components/Navigation";

import FormExterno from "../../components/FormExterno";

const Mapas = () => {

    const [src, setSrc] = useState([])

    useEffect(() => {

        dataProvider.getAll('WsSanEndPoints.rule?sys=SAS').then((response) => {
            //console.log(response.data)
            console.log(response.data.linkMapa)
            if (typeof response.data.linkMapa !== 'undefined') {

                //console.log(response.data.linkMapa)
                setSrc(response.data.linkMapa)

            }

        })

    }, []);

    return (
        <>

            <Navigation titulo="Mapa" />

            <FormExterno src={src} />

        </>
    )
}

export default Mapas;
